import React from 'react';

import validate from '@vlabs/shared/validators';
import {
  Control, Margin, Grid, GridRow, GridCol,
} from '@vlabs/uikit';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import st from './CreateHandlerForm.module.sass';

interface BiometricIdentificationFaceQualityFormProps {
  listOptions?: {
    label: string;
    value: string;
  }[];
  onSubmit: (values: unknown) => void;
}
function BiometricIdentificationFaceQualityForm({
  listOptions = undefined,
  onSubmit,
}: BiometricIdentificationFaceQualityFormProps): React.JSX.Element {
  const { t } = useTranslation();
  const {
    register, control, handleSubmit, formState: { errors },
  } = useForm();

  return (
    <form
      data-testid="modal.faceQuality"
      onSubmit={handleSubmit(onSubmit)}
    >
      <Grid>
        <GridRow>
          <GridCol>
            <Margin display="block">
              <span className={st.Description}>
                {t('handlers:face_quality.policy_description')}
              </span>
            </Margin>
            <Margin display="block">
              <div className="Body-2">{t('handlers:form.policy_name')}</div>
              <Control.Input
                {...register('description', {
                  maxLength: validate.maxLength(128),
                  required: validate.required(),
                })}
                errors={errors}
              />
            </Margin>
            <Margin display="block">
              <div className="Body-2">
                {t('handlers:face_quality.form.list_to_save_descriptor')}
              </div>
              <Control.Select
                control={control}
                errors={errors}
                id="listId"
                name="listId"
                options={listOptions}
                rules={{ required: validate.required() }}
              />
            </Margin>
          </GridCol>
        </GridRow>
      </Grid>
      <Margin display="block">
        <Control.Button
          fullWidth
          type="submit"
        >
          {t('handlers:create')}
        </Control.Button>
      </Margin>
    </form>
  );
}

export default BiometricIdentificationFaceQualityForm;
